import Http from '@/api/http.js'

export default {

  index(filters) {
    return Http.get(`/shippings`, {params: {...filters}})
  },
  indexByModel({model, id, filters}) {
    return Http.get(`${model}/${id}/shippings`, {params: {...filters}})
  },
  update(shipping){
    return Http.put(`/shippings/${shipping.id}`, {
      shipping: {...shipping},
    });
  },
  show(id) {
    return Http.get(`/shippings/${id}`);
  },

}
